import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        background: "#4ca5e6ff", // Light gray for professional medical app
        primary: "#1976D2",
        // Alternative background options:
        // background: "#FFFFFF", // Pure white (default)
        // background: "#E3F2FD", // Light blue tint to match primary
        // background: "#F5F5F5", // Neutral light gray
        // background: "#FAFAFA", // Warmer light gray
      },
      options: {
        customProperties: true,
      },
    },
  },
});
